import Component from '../core/Component'

export const STATES = {
  ACTIVE: 'is-active'
}

export default class AccordionSlider extends Component {
  constructor(element) {
    super(element)

    this.ref = {
      acslides: [],
      accordion: null,
      slider: null
    }
  }

  prepare() {
    this.ref.accordion.addEventListener('itemOpened', (e) => {
      this.open(e.detail)
    })
    this.ref.slider.addEventListener('itemOpened', (e) => {
      this.open(e.detail)
      this.ref.accordion.dispatchEvent(new CustomEvent('open', { detail: e.detail }))
    })
  }

  open(acslideIndex) {
    const item = this.ref.acslides[acslideIndex]
    item.classList.add(STATES.ACTIVE)

    this.ref.acslides.forEach((item, index) => {
        if (index !== acslideIndex) {
            item.classList.remove(STATES.ACTIVE)
            // remove seen class from animated components in order to restart them
            if(item.querySelector('.seen')){
              item.querySelector('.seen').classList.remove("seen")
            }
        }
    })
  }
}